export const isShowCreator = (state) =>
  state.auth.userProfile?.data?.userRoles?.some((item) => item.userRoleName.includes('Creator'));

export const isShowAdministrator = (state) =>
  state.auth.userProfile?.data?.userRoles?.some((item) => item.userRoleName.includes('Admin'));

export const isShowApprover = (state) =>
  state.auth.userProfile?.data?.userRoles?.some((item) => item.userRoleName.includes('Approver'));
